import { useMemo } from 'react';
import { keepPreviousData } from '@tanstack/react-query';
import { useGetVenuaPlannerCalendarTerms } from '@/api/generated/venua-planner-planning/venua-planner-planning';
import { buildCalendarEvents, isoDate, monthGridRange, type CalendarEvent } from './calendarModel';

/**
 * Načte termíny pro viditelné okno měsíčního gridu (Po prvního týdne až Ne posledního)
 * a namapuje je na `CalendarEvent[]`. `keepPreviousData` drží předchozí měsíc při ‹ › navigaci.
 */
export function useCalendarTerms(month: Date): {
  events: CalendarEvent[];
  isLoading: boolean;
  isError: boolean;
  error: unknown;
} {
  const { gridStart, gridEnd } = monthGridRange(month);

  const query = useGetVenuaPlannerCalendarTerms(
    { from: isoDate(gridStart), to: isoDate(gridEnd) },
    { query: { placeholderData: keepPreviousData } }
  );

  const events = useMemo(() => (query.data ? buildCalendarEvents(query.data) : []), [query.data]);

  return { events, isLoading: query.isLoading, isError: query.isError, error: query.error };
}
